import {
    FETCH_GRUPOS_CLIENTES_DATA, FETCH_GRUPOS_CLIENTES_SUCCESS, FETCH_GRUPOS_CLIENTES_FAILURE,
} from '../actions/types';

const initialState = {
    isLoading: false,
    payload: [],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case FETCH_GRUPOS_CLIENTES_DATA:
            return {
                ...state,
                isLoading: true
            };

        case FETCH_GRUPOS_CLIENTES_SUCCESS:
            return {
                ...state,
                payload: action.payload,
                isLoading: false
            };

        case FETCH_GRUPOS_CLIENTES_FAILURE:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
            
        default:
            return state;
    }
}

export default reducer;